import { render, staticRenderFns } from "./FamilyLawMatterInstructions.vue?vue&type=template&id=37afef07&scoped=true"
import script from "./FamilyLawMatterInstructions.vue?vue&type=script&lang=ts"
export * from "./FamilyLawMatterInstructions.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=37afef07&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37afef07",
  null
  
)

export default component.exports